import { FC } from "react";
import useContractation from "@/components/Contractation/hooks/useContractation";
import { ListGroup, ListItem } from "@gisce/oficina-virtual-components";
import { AddBox } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

const ContractationListItems: FC = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activeContractations, isContractationPath } = useContractation();

  return (activeContractations.num > 1 ?
    <ListGroup
      icon={<AddBox />}
      titleLabel={t('common:text.new_customer_title')}
      startOpen={ isContractationPath(pathname) }
    >
      {activeContractations.types.electricity.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.electricity")})}
          onClick={() => navigate(t(activeContractations.types.electricity.untranslatedPath))}
          selected={pathname === t(activeContractations.types.electricity.untranslatedPath)}
        />
      )}
      {activeContractations.types.gas.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.gas")})}
          onClick={() => navigate(t(activeContractations.types.gas.untranslatedPath))}
          selected={pathname === t(activeContractations.types.gas.untranslatedPath)}
        />
      )}
      {activeContractations.types.dual.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.dual")})}
          onClick={() => navigate(t(activeContractations.types.dual.untranslatedPath))}
          selected={pathname === t(activeContractations.types.dual.untranslatedPath)}
        />
      )}
    </ListGroup>
  :
    <>
      {activeContractations.types.electricity.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.electricity")})}
          onClick={() => navigate(t(activeContractations.types.electricity.untranslatedPath))}
          selected={pathname === t(activeContractations.types.electricity.untranslatedPath)}
        />
      )}
      {activeContractations.types.gas.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.gas")})}
          onClick={() => navigate(t(activeContractations.types.gas.untranslatedPath))}
          selected={pathname === t(activeContractations.types.gas.untranslatedPath)}
        />
      )}
      {activeContractations.types.dual.enabled && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.dual")})}
          onClick={() => navigate(t(activeContractations.types.dual.untranslatedPath))}
          selected={pathname === t(activeContractations.types.dual.untranslatedPath)}
        />
      )}
    </>
  );
}

export default ContractationListItems;